import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: [],
};

const scanRateLimitSlice = createSlice({
  name: 'scanRateLimit',
  initialState,
  reducers: {
    setScanRateLimitList(state, action) {
      state.list = action.payload;
    },
  },
});

export default scanRateLimitSlice.reducer;
export const { setScanRateLimitList } = scanRateLimitSlice.actions;
